import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import { Grid, Typography } from '@mui/material'
import crearCuenta from './crea-tu-cuenta.jpg'
import descargarCliente from './descarga-el-cliente-.jpg'
import ComenzaJugar from './comenza-a-jugar.jpg'
import { IoLogoGameControllerA } from 'react-icons/io'
import { BsPeopleFill } from 'react-icons/bs'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './home.css'
import cheerio from 'cheerio';
import axios from 'axios';


function Home(props) {
    const [user, setUser] = useState({});

    /*
        async function getUserByIdTheToken(token) {
            console.log(token);
    
            try {
                const response = await axios.get('https://backmu.vercel.app/getUserByIdTheToken', {
                    headers: {
                        Authorization: `Bearer ${token}`,
    
                    },
                });
                return response.data;
            } catch (error) {
                return {
                    error
                }
            }
        }
        useEffect(() => {
            async function getUser() {
                let token = window.localStorage.getItem("token");
                let res = await getUserByIdTheToken(token);
                console.log(res);
                if (res.username) {
                    setUser(res);
                }
            }
            getUser();
            console.log('user', user)
        }, []);
    */

    const CountdownTimer = ({ targetDate }) => {
        const calculateTimeLeft = () => {
            const difference = +new Date(targetDate) - +new Date();
            let timeLeft = {};

            if (difference > 0) {
                timeLeft = {
                    Days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    Hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    Minutes: Math.floor((difference / 1000 / 60) % 60),
                    Seconds: Math.floor((difference / 1000) % 60),
                };
            }

            return timeLeft;
        };

        const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

        useEffect(() => {
            const timer = setTimeout(() => {
                setTimeLeft(calculateTimeLeft());
            }, 1000);

            return () => clearTimeout(timer);
        });

        const timerComponents = [];

        Object.keys(timeLeft).forEach((interval) => {
            if (!timeLeft[interval]) {
                return;
            }

            timerComponents.push(
                <span style={{ display: 'flex', flexDirection: 'column', padding: '5px', alignItems: 'center' }} key={interval}>
                    <span style={{ color: 'white', fontSize: '24px', fontWeight: 600 }}>{timeLeft[interval]}</span>
                    <span style={{ color: 'white', fontSize: '18px' }}>{interval}{' '}</span>
                </span>
            );
        });

        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                {timerComponents.length ? (
                    timerComponents
                ) : (
                    <span>¡La fecha límite ha pasado!</span>
                )}
            </div>
        );
    };
    const targetDate = new Date('July 30, 2024 00:00:00');
    const [news, setNews] = useState([]);
    const [formData, setFormData] = useState({
        title: '',
        content: '',
        author: ''
    });

    // Función para obtener la lista de noticias
    const fetchNews = async () => {
        try {
            const response = await axios.get('https://backmu.vercel.app/news');
            setNews(response.data);
        } catch (error) {
            console.error('Error al obtener noticias:', error);
        }
    };

    // Función para enviar la solicitud de creación de noticia
    const handleCreateNews = async () => {
        try {
            const response = await axios.post('https://backmu.vercel.app/news', formData);
            console.log(response.data); // Deberías recibir el mensaje indicando que la noticia se creó exitosamente
            // Actualiza la lista de noticias después de crear una nueva
            fetchNews();
            // Reinicia el formulario
            setFormData({ title: '', content: '', author: '' });
            setHabilitarCrear(!habilitarCrear)
        } catch (error) {
            console.error('Error al crear noticia:', error);
        }
    };
    const handleDeleteNews = async (id) => {
        try {
            const response = await axios.delete(`https://backmu.vercel.app/news/${id}`);
            console.log(response.data); // Deberías recibir el mensaje indicando que la noticia se eliminó exitosamente
            // Actualiza la lista de noticias después de eliminar una noticia
            fetchNews();
        } catch (error) {
            console.error('Error al eliminar noticia:', error);
        }
    };

    // Efecto para cargar la lista de noticias cuando el componente se monta
    useEffect(() => {
        fetchNews();
    }, []);

    const [habilitarCrear, setHabilitarCrear] = useState()
    return (
        <Layout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded} isMobile={props.isMobile} >
            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '35px', padding: props.isMobile ? '2rem 1rem' : '2rem 5.8rem' }}>
                {/* <Grid className='banner2'></Grid> */}
                <Grid className='banner1'>

                    {/* <CountdownTimer targetDate={targetDate} /> */}
                </Grid>
                {/*IMAGES*/}
                {
                    props.isMobile &&
                    <Swiper
                        spaceBetween={5}
                        slidesPerView={1}
                        navigation
                        pagination
                        scrollbar={{ draggable: true }}
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                        style={{ width: '100%', height: 'auto' }} // Asegurando tamaño adecuado
                    >

                        <SwiperSlide style={{ color: 'white' }}>
                            <img src={crearCuenta} alt="Crear Cuenta" style={{ borderRadius: '5px', width: '100%' }} />
                        </SwiperSlide>

                        <SwiperSlide style={{ color: 'white' }}>
                            <img src={descargarCliente} alt="Descargar Cliente" style={{ borderRadius: '5px', width: '100%' }} />
                        </SwiperSlide>

                        <SwiperSlide style={{ color: 'white' }}>
                            <img src={ComenzaJugar} alt="Comenzar a Jugar" style={{ borderRadius: '5px', width: '100%' }} />
                        </SwiperSlide>

                        {/* <SwiperSlide style={{ color: 'white' }}>
                            <img src={descargarCliente} style={{ borderRadius: '5px' }} />
                        </SwiperSlide>

                        <SwiperSlide style={{ color: 'white' }}>
                            <img src={ComenzaJugar} style={{ borderRadius: '5px' }} />
                        </SwiperSlide> */}

                    </Swiper>
                }

                {
                    !props.isMobile &&
                    <Grid style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                        <img src={crearCuenta} style={{ borderRadius: '5px' }} className='img-swiper'></img>
                        <img src={descargarCliente} style={{ borderRadius: '5px' }} className='img-swiper'></img>
                        <img src={ComenzaJugar} style={{ borderRadius: '5px' }} className='img-swiper'></img>
                    </Grid>
                }




                {/*NOTICIAS */}

                <Grid style={{ display: 'flex', justifyContent: 'space-between', flexDirection: props.isMobile && 'column', gap: props.isMobile && '10px' }}>

                    <Grid style={{ border: '1px solid #343843', display: 'flex', borderRadius: '5px', width: props.isMobile ? '100%' : '80%', flexDirection: 'column', gap: '10px', padding: '10px' }}>

                        <Grid style={{ padding: '5px', borderBottom: '1px solid #343843' }}>
                            <Typography style={{ color: 'white' }}>Noticias</Typography>
                        </Grid>

                        <Grid style={{ padding: '5px', gap: '10px', display: 'flex', flexDirection: 'column' }}>

                            {
                                user.rol === 'admin' ?
                                    news.length >= 1 ?
                                        <Grid style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                            <button style={{ width: '30%' }} onClick={() => setHabilitarCrear(!habilitarCrear)} > {habilitarCrear ? 'Cerrar' : 'Crear Noticia'}</button>

                                            {news.map((item) => (
                                                <Grid style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                    <Grid style={{ display: 'flex', alignItems: 'center', border: '1px solid #343843', borderRadius: '5px', padding: '5px' }}>
                                                        <Grid style={{ width: '10%', display: 'flex', justifyContent: 'center' }}>
                                                            <IoLogoGameControllerA style={{ color: 'white', fontSize: '50px', margin: '0 auto' }} />
                                                        </Grid>

                                                        <Grid style={{ width: '90%', display: 'flex', flexDirection: 'column' }}>
                                                            <Typography variant='h5' style={{ color: 'white', fontSize: '20px' }}>
                                                                {item.title}
                                                            </Typography>

                                                            <Typography style={{ color: 'white' }}>
                                                                {item.content}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>

                                                    <button onClick={() => handleDeleteNews(item._id)} style={{ width: '10%' }}>Eliminar</button>
                                                </Grid>
                                            ))}

                                        </Grid>

                                        :

                                        user.rol === 'admin' ?
                                            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                <button style={{ width: '10%' }} onClick={() => setHabilitarCrear(!habilitarCrear)} > {habilitarCrear ? 'Cerrar' : 'Crear Noticia'}</button>
                                                <Typography style={{ color: 'white', fontStyle: 'italic' }}> No existen noticias en estos momentos</Typography>
                                            </Grid>

                                            : <Typography style={{ color: 'white', fontStyle: 'italic' }}> No existen noticias en estos momentos</Typography>
                                    :
                                    news.length >= 1 ?
                                        news.map((item) => (
                                            <Grid style={{ display: 'flex', alignItems: 'center', border: '1px solid #343843', borderRadius: '5px', padding: '5px', gap: '10px' }}>
                                                <Grid style={{ width: '10%', display: 'flex', justifyContent: 'center' }}>
                                                    <IoLogoGameControllerA style={{ color: 'white', fontSize: '50px', margin: '0 auto' }} />
                                                </Grid>

                                                <Grid style={{ width: '90%', display: 'flex', flexDirection: 'column' }}>
                                                    <Typography variant='h5' style={{ color: 'white', fontSize: '20px' }}>
                                                        {item.title}
                                                    </Typography>

                                                    <Typography style={{ color: 'white' }}>
                                                        {item.content}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                        ))
                                        :
                                        <Typography style={{ color: 'white', fontStyle: 'italic' }}> No existen noticias en estos momentos</Typography>


                            }



                            {user.rol === 'admin' && habilitarCrear ?
                                <Grid style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <h2>Crear Noticia</h2>
                                    <input type="text" name="title" placeholder="Título" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} />
                                    <textarea type="textarea" name="content" placeholder="Contenido" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} />

                                    <button onClick={handleCreateNews}>Crear Noticia</button>
                                </Grid>
                                : <></>
                            }
                        </Grid>




                    </Grid>




                    <Grid style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', width: props.isMobile ? '100%' : '15%', padding: '5px', border: '1px solid #343843', borderRadius: '5px' }}>
                        <BsPeopleFill style={{ color: 'white', fontSize: '50px' }} />

                        <Typography style={{ fontWeight: 600, fontSize: '24px', color: 'white' }}>¿Necesitas ayuda?</Typography>

                        <Typography style={{ fontSize: '18px', color: 'white' }}>Provable fairness is a concept in online gaming</Typography>
                    </Grid>

                </Grid>
            </Grid>
        </Layout>
    )
}

export default Home